import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserContext } from '../components/UserContext';
import { Watch } from 'react-loader-spinner';
import {
  Row,
  Col,
  Modal,
  Form,
  Button,
  Toast,
  ToastContainer,
} from 'react-bootstrap';
import { RiDeleteBin6Line } from 'react-icons/ri';
import axios from 'axios';
import SideNav from '../components/SideNav';
import './MyGroup.css';

const apiUrl = process.env.REACT_APP_API_URL;

const NewMyGroup = () => {
  const { userId } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const { groupId } = useParams();
  const [creatorId, setCreatorId] = useState();
  const [creatorName, setCreatorName] = useState();
  const navigate = useNavigate();
  const [groupDetails, setGroupDetails] = useState(null);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const [emailInput, setEmailInput] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success');
  const [showToast, setShowToast] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');
      const isLoggedIn = Boolean(token);

      try {
        if (!groupId || !isLoggedIn) {
          navigate('/signup');
          return;
        }

        const response = await axios.get(
          `${apiUrl}/groups/${groupId}?includeUserNames=true&includeCreatorName=true`,
          {
            headers: {
              'x-auth-token': token,
            },
          },
        );

        if (response.data) {
          console.log('response.data:: ', response.data);
          setGroupDetails(response.data);
          setCreatorName(response.data.creatorId?.name);
          setCreatorId(response.data.creatorId?.name);
        }
      } catch (error) {
        console.error('Error fetching group details:', error);
        setError('Failed to load group details');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [groupId, navigate]);

  const deleteGroup = async (e, groupId, userId) => {
    e.preventDefault();
    if (!groupId || !userId) {
      setToastMessage('Unable to delete group: Missing information');
      setToastType('error');
      setShowToast(true);
      return;
    }

    if (window.confirm('Are you sure you want to delete this group?')) {
      const token = localStorage.getItem('token');
      try {
        await axios.post(
          `${apiUrl}/groups/delete`,
          { groupId, userId },
          {
            headers: {
              'x-auth-token': token,
            },
          },
        );
        navigate('/userwelcome');
      } catch (error) {
        console.error('Failed to delete group:', error);
        setToastMessage('Failed to delete group');
        setToastType('error');
        setShowToast(true);
      }
    }
  };

  const addEmailToList = () => {
    if (emailInput.trim() !== '') {
      setEmailList((prevList) => [...prevList, emailInput.trim()]);
      setEmailInput('');
    }
  };

  const removeEmailFromList = (index) => {
    setEmailList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const handleSendInvites = async () => {
    if (!emailList.length) return;

    const token = localStorage.getItem('token');
    try {
      await axios.post(
        `${apiUrl}/groups/send-invite`,
        {
          groupname: groupDetails?.groupname,
          invitees: emailList,
        },
        {
          headers: {
            'x-auth-token': token,
          },
        },
      );
      setToastMessage('Invitations sent successfully!');
      setToastType('success');
      setShowToast(true);
      setShowInviteModal(false);
      setEmailList([]);
    } catch (error) {
      console.error('Failed to send invitations:', error);
      setToastMessage('Failed to send invitations');
      setToastType('error');
      setShowToast(true);
    }
  };

  if (loading) {
    return (
      <Row>
        <Col md={2} className="sidebar">
          <SideNav />
        </Col>
        <Col md={10}>
          <div className="d-flex justify-content-center align-items-center vh-75">
            <div className="loading-section">
              <Watch
                visible={true}
                height="40"
                width="40"
                radius="48"
                color="#4fa94d"
                ariaLabel="watch-loading"
              />
              <p className="loading-text">
                "The two most powerful warriors are patience and time." – Leo
                Tolstoy
              </p>
            </div>
          </div>
        </Col>
      </Row>
    );
  }

  if (error) {
    return (
      <Row>
        <Col md={2} className="sidebar">
          <SideNav />
        </Col>
        <Col md={10}>
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        </Col>
      </Row>
    );
  }

  if (!groupDetails) {
    return (
      <Row>
        <Col md={2} className="sidebar">
          <SideNav />
        </Col>
        <Col md={10}>
          <div className="alert alert-warning" role="alert">
            No group details found
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row>
        <Col md={2} className="sidebar">
          <SideNav />
        </Col>
        <Col md={10}>
          <div className="wrapper-group-detail">
            <div className="wrapper-box">
              <Row className="fs-group">
                <Col md={8} className="first-section-group">
                  <div className="content-group-title">
                    <p>{groupDetails.groupname}</p>
                  </div>
                  <div className="content-group-description">
                    <p>{groupDetails.description}</p>
                  </div>
                </Col>
                <Col md={4} className="control-section-group">
                  <div className="button-section">
                    <div
                      onClick={() => navigate('groupcycle')}
                      style={{ cursor: 'pointer' }}
                      className="create-btn"
                    >
                      Create Cycle
                    </div>

                    <div
                      onClick={() => setShowInviteModal(true)}
                      className="add-members-btn"
                    >
                      Add Members
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="grey-line"></div>
              <div className="member-details">
                <div className="creator-details">
                  <p className="creator-title">Creator </p>
                  <p className="creator-icon">
                    {(creatorName && creatorName.charAt(0).toUpperCase()) ||
                      'U'}
                  </p>
                  <p className="creator-name">
                    {creatorName || 'Unknown User'}
                  </p>
                </div>
                <div className="member-names">
                  <p className="member-title">
                    Members({groupDetails.users?.length || 0})
                  </p>
                  <p className="members-icon-list">
                    {groupDetails.users?.map(
                      (user, index) =>
                        user && (
                          <p
                            key={user._id || `user-${index}`}
                            className="single-group-member-icon"
                          >
                            {user.name?.charAt(0).toUpperCase() || 'U'}
                          </p>
                        ),
                    )}
                  </p>
                </div>
              </div>
              <div className="grey-line"></div>
              {groupDetails.aboutMembers && (
                <div className="about-section-group-single">
                  <div className="title-about-group-single">
                    <p>About our members</p>
                  </div>
                  <div className="about-group-single-desc">
                    {groupDetails.aboutMembers}
                  </div>
                </div>
              )}
              {userId === groupDetails.creatorId?._id && (
                <div
                  onClick={(e) => deleteGroup(e, groupId, userId)}
                  className="delete-section-group-single"
                >
                  <div className="delete-bin">
                    <RiDeleteBin6Line />
                  </div>
                  <div className="delete-text">delete</div>
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Modal show={showInviteModal} onHide={() => setShowInviteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Members</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="emailInput">
            <Form.Label>Enter email addresses</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  addEmailToList();
                }
              }}
            />
            <Button variant="primary" onClick={addEmailToList} className="mt-2">
              Add Email
            </Button>
          </Form.Group>
          <div className="mt-3">
            {emailList.map((email, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <span>{email}</span>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => removeEmailFromList(index)}
                >
                  Remove
                </Button>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowInviteModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSendInvites}>
            Send Invites
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          bg={toastType}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body className={toastType === 'success' ? 'text-white' : ''}>
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default NewMyGroup;
